import { Component, Injector, ElementRef, EventEmitter, Inject, Input, OnInit, Output, Renderer, ViewEncapsulation, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable, } from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';
import { Subject } from 'rxjs/Subject';

import { Translations } from './lookupedit.translation';
import { Multilingual } from '../../models/multilingual';
import { UiComponent } from '../ui/ui.component';
import { GenericdatasetService } from '../../services/genericdataset/genericdataset.service';
import { ValidatorService } from '../../services/validator/validator.service';
import { ReactiveformService } from '../../services/reactiveform/reactiveform.service';

import { LookupEditRoutingModule } from './lookupedit.routing.module';

import { GenericListModalService } from '../../services/genericlistmodal/genericlistmodal.service';

declare const $: any;
const idEmpty: number = 111;
const errorMessage: any = {
  required: 'Ce champ est requis'
};

@Component({
  selector: 'lookupedit',
  template: `
  <div *ngIf="visible" class="md-form form-sm" [ngClass]="{'has-error':error}">
    <div [ngStyle]="{'display': (control?.value > 111 ? '' :'flex')}">
        <i *ngIf="glyph" class="{{glyph}} prefix" [ngClass]="{'active':control?.value > 111}" style="top: -0.3rem;"></i>
        <span style="display: inline-table;" [ngStyle]="{'margin-left': (glyph ? '2.2rem' :'')}">
            <span *ngFor="let column of columns; let i = index" [ngStyle]="{'opacity': (readonly ? '.8' :'')}" data-toggle="tooltip"
                title="{{columns[i].hint}}" (dblclick)="openDblClick()" class="badge badge-{{columns[i].status}}" style="cursor:pointer;margin-right: 5px;">{{getCaption(i)}}</span>
        </span>
        <input type="text" (dblclick)="openList('')" class="form-control lookupeditcomp" [ngClass]="{'invalid':error}" id="{{name}}"
            name="{{name}}" style="display: -webkit-inline-box;width: calc(100%);margin-left:0rem;" [ngStyle]="{'display': (control?.value > 111 ? 'none' :'')}"
            #input placeholder="{{placeholder()}}" value="" [readonly]="readonly">
        <label [attr.for]="name" [ngStyle]="{'top': (!(id > 111) ? '.5rem' :'')}" style="text-align:left; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;"
            class="active">
            <em *ngIf="readonly">{{caption}}</em>
            <b *ngIf="!readonly">{{caption}}</b>
            <span *ngIf="required && !(control?.value > 111)" style="color: red;">
                <b> *</b>
            </span>
            <i *ngIf="readonly" class="fa fa-lock" style="color:rgba(0, 0, 0, 0.54) !important;"></i>
        </label>
        <a *ngIf="!readonly && control?.value > 111" [ngClass]="{'disabled':readonly}" style="font-size: .9rem!important;vertical-align: middle;"
            data-toggle="tooltip" title="{{ ui.clear }}" (click)="clear()">
            <i class="fa fa-remove fa-lg" style="color:rgba(0, 0, 0, 0.54) !important;"></i>
        </a>
    </div>
    <span *ngIf="error" class="help-block text-danger" [ngStyle]="{'padding-left': (glyph ? '34px' :'')}" style="font-size: 15px">
        <b>{{ error }}</b>
    </span>
    <div [hidden]="true">
        <input type="text" [formControl]="control">
    </div>
  </div>`,
  styles: [`
  .md-form, .md-form .btn {
      margin-bottom: 1.5rem;
      margin-top: .8rem;
  }
  .prefix {
    display: inline-table;
  }
  .btn-lookupedit {
    padding: .85rem 1rem;
  }
  .input-group-btn {
      display: inline-block;
  }
  .md-form.input-group .form-control {
      padding-left: 0px;
  }

  .lookupeditcomp {
      margin-bottom: 0;
  }

  .lookupeditcomp.ng-invalid {
      border-bottom: 1px solid #F44336;
      box-shadow: 0 1px 0 0 #F44336;
  }

  input[type=text]:focus:not([readonly]) {
      border-color: #007bff !important;
      box-shadow: 0 1px 0 0 #007bff !important;
  }

  a.disabled {
    pointer-events: none;
    cursor: default;
  }`],
  encapsulation: ViewEncapsulation.None
})

export class LookupEditComponent extends Multilingual implements OnInit {
  @Input() public name: string = '';
  @Input() public caption: string;
  @Input() public length: string = '0';
  //@Input() public placeholder: string = "";
  @Input() public enabled: boolean = false;
  @Input() public _required: boolean = false;
  @Input() public hiddenNotEmpty: boolean = false;
  @Input() public control: AbstractControl;
  @Input() public visible: boolean = true;
  @Input() public readonly: boolean = false;
  @Input() public value: String = '';
  @Input() public glyph: string = '';
  @Input() public form: FormGroup;
  @Input() public error: any;
  @Input() public title: string = '';
  @Input() public lookFieldName: string;
  @Input() public templateNameList: any;
  @Input() public templateNameRecord: any;
  @Input() public restName: string;
  @Input() public _href: string;
  @Input() public id: any;
  @Input() public loading = true;
  public _columns: any = [{ caption: 'name', status: 'default' }];
  @Input() public item: any;
  @Input() public size: any;
  @Input() public filter: string;
  @Input() public include: string[];
  @Input() public infinite: boolean = true;
  @Output() updated: EventEmitter<any> = new EventEmitter();
  @ViewChild('input') public input: ElementRef;
  expanded = false;
  public modalId: number;
  public ui: any = {};
  public initialized: boolean = false;
  public valueSearch: Subject<string>;

  constructor(
    injector: Injector,
    public router: Router,
    public itemService: GenericdatasetService,
    public validatorService: ValidatorService,
    private renderer: Renderer,
    public genericlistService: GenericListModalService,
    public reactiveformService: ReactiveformService
  ) {
    super(injector);
    this.setTranslations(Translations); 
  }

  ngOnInit(): void {
    this.initialize();
    //this.Required(this.required);
  }

  @Input() public set columns(columns: any) {
    let result = [];
    if (columns) {
      for (let i = 0; i <= columns.length - 1; i++) {
        if (columns[i]) {
          if (typeof columns[i] == 'string') {
            result.push({ caption: columns[i], status: 'default', hint: columns[i].charAt(0).toUpperCase() + columns[i].substr(1).toLowerCase() });
          } else {
            if (!columns[i].status) columns[i].status = 'default';
            if (!columns[i].hint) columns[i].hint = columns[i].caption.charAt(0).toUpperCase() + columns[i].caption.substr(1).toLowerCase();
            result.push(columns[i]);
          }
        }
      }
    } else {
      result = ['name'];
    }
    this._columns = result;
  }

  public get columns() {
    return this._columns;
  }

  @Input() public set required(required: boolean) {
    if (required && this.control) {
      this.control.setValidators(this.validatorService.isRequire);
    } else if (this.control) {
      this.control.clearValidators();
    }
    this._required = required;
  }

  public get required() {
    return this._required;
  }

  @Input() public set href(href: string) {
    this._href = href;
    if (!this.restName) this.restName = this._href;
  }

  public get href() {
    return this._href;
  }

  initialize() {
    if (!this.control) {
      if (this.form.controls[this.name] == null) {
        this.control = new FormControl();
        this.form.addControl(this.name, this.control);
      }
      this.control = this.form.controls[this.name];
    }
    this.item = {};
    if (!this.lookFieldName) {
      this.lookFieldName = 'id';
    }
    if (this.control.value == undefined) {
      this.control.patchValue(idEmpty);
    }
    this.id = this.control.value;
    if (this.hiddenNotEmpty) {
      this.visible = this.id <= idEmpty;
    }
    this.load();
    this.control.valueChanges.subscribe((value) => {
      let updated: boolean = value != this.id;
      if (value != this.id) {
        this.id = value;
      }
      this.load(updated);
      this.returnError();
    });
    this.required = this._required;
  }

  ngAfterViewInit() {
    if (this.input) {
      const eventStream = Observable.fromEvent(this.input.nativeElement, 'keyup')
        .map(() => this.input.nativeElement.value)
        .debounceTime(500);
      eventStream.subscribe((input: any) => {
        this.valueSearch.next(input);
      });
      this.valueSearch = new Subject();
      this.valueSearch.next(this.input.nativeElement.value);
      this.valueSearch.subscribe((newValue: any) => {
        //if (newValue) $(this.input.nativeElement).blur();
        this.openKeyUp(newValue);
      });
    }
  }

  returnError() {
    this.error = '';
    if (this.control && !this.control.valid && this.control.errors) {
      for (const key in this.control.errors) {
        if (key in errorMessage) {
          this.error += errorMessage[key] + ' ';
        }
      }
    }
  }

  loadItem(item: any) {
    this.item = item;
  }

  afterLoad(item: any) {
  }

  load(updated?: boolean) {
    this.loading = true;
    this.itemService.setrestName(this.restName);
    this.itemService
      .getItem(this.id, this.include)
      .subscribe(
      (item) => {
        this.loadItem(item);
        this.afterLoad(item);
        if (updated) {
          this.updated.emit(this.id);
        }
      },
      (error) => {
        this.error = JSON.parse(error);
        this.loading = false;
      },
      () => {
        this.loading = false;
      });
  }

  openKeyUp(value: any) {
    if (value) {
      this.openList(value);
    }
  }

  openList(key: string): void {
    this.openModal(true, this.templateNameList, key);
  }

  openRecord(): void {
    this.reactiveformService.backLink = this.router.url;
    let id: number = this.id;
    if (this.id == idEmpty) { id = 0 }
    let route = ['/', this.href, id];
    if (this.templateNameRecord) {
      route = ['/', this.href, this.templateNameRecord, id];
    }
    this.router.navigate(route);
  }

  getCaption(i: number) {
    if (this.item) {
      if (this.columns[i].include) {
        if (!(this.columns[i].include in this.item))
          return "";
        else
          return this.item[this.columns[i].include][this.columns[i].caption];
      }
      else {
        if (!(this.columns[i].caption in this.item))
          return "";
        else
          return this.item[this.columns[i].caption];
      }
    } else {
      return "";
    }
  }

  close(item: any) {
    if (item == undefined) {
      this.valueSearch.next('');
      this.focus(); return;
    }
    let id = 0;
    if (typeof item == 'number') {
      id = item;
    } else {
      id = item[0].id;
    }
    this.updateValue(id);
  }

  focus() {
    setTimeout(() => {
      this.renderer.invokeElementMethod(this.input.nativeElement, 'focus');
    }, 1);
  }

  clear() {
    if (this.readonly) { return; }
    this.updateValue(idEmpty);
  }

  updateValue(id: number) {
    this.control.patchValue(id);
    if (id == idEmpty) {
      this.focus();
    }
  }

  placeholder() {
    if (this.readonly && this.control.value)
      return "";
    else
      return "Recherche...";
  }

  openModal(list: boolean, templateName: string, key: string): void {
    /*let parameters;
    parameters = {
      modal: true,
      close: (id: any) => {
        this.close(id);
      },
      options: {},
      id: 0
    };
    if (list) {
      parameters.options = { restName: this.restName, title: this.title, href: this.href, filter: this.filter, listFilter: key, infinite: this.infinite, templateNameRecord: this.templateNameRecord };
    } else {
      parameters.id = this.id;
      if (this.templateNameRecord == 'Generic') {
        parameters.options = { restName: this.restName, glyph: this.glyph, title: this.title, backLink: this.restName };
      }
    }*/
    //this.modalId = this.placeholderService.addModal(templateName, parameters);
    this.genericlistService.restName = this.restName;
    this.genericlistService.title = this.title;
    this.genericlistService.href = this.href;
    this.genericlistService.filter = this.filter;
    this.genericlistService.listFilter = key;
    this.genericlistService.infinite = this.infinite;
    this.genericlistService.templateNameRecord = this.templateNameRecord;
    this.genericlistService.close = (id: any) => {
      this.input.nativeElement.value = '';
      this.close(id);
    }
    this.genericlistService.displayed = true;
  }

  openClick() {
    this.openRecord();
  }

  openDblClick() {
    if (this.id > idEmpty) {
      this.openRecord();
    } else {
      this.openList('');
    }
  }

  getOpenButtonClass(): String {
    if (this.id > idEmpty) {
      return 'fa fa-external-link fa-lg d-none d-md-flex';
    } else {
      return 'fa fa-caret-down fa-lg';
    }
  }

  getId(): number {
    return this.id;
  }

  setId(id: number) {
    if (this.hiddenNotEmpty) {
      this.visible = id <= idEmpty;
    }
    this.updateValue(id);
  }

  setVisible(visible: boolean) {
    this.visible = visible;
  }

  setReadonly(readonly: boolean) {
    this.readonly = readonly;
  }
}
